module.exports = __webpack_public_path__ + "img/038-graphic designer.64d5503d.png";